export const contact = {
    customerService: {
        phone: '01 84 17 36 79',
        email: 'service-client@lepotcommun.fr',
    },
};

export default contact;
